import { HttpErrorResponse } from '@angular/common/http';
import { createSelector } from 'reselect';
import { Action } from '@ngrx/store';

import { AppState } from '../../app.state';
import { Locale } from '../../shared/models/locale.model';

import * as localeActions from './locale.actions';

const initialState: Locale = null;

export function localeReducer(state = initialState, action: Action): Locale {
  switch (action.type) {
    case localeActions.actionTypes.SET_LOCALE:
      return action.payload;

    default:
      return state;
  }
}

export const getLocale = (state: AppState) => state.locale;



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/locale/locale.reducer.ts